/**
 * 圆形带阴影的 icon 按钮
 * @author jinchenhao <jinchenhao@reversible.cn>
 * @since 2020-09-20 17:13:45
 */

import React, { FC } from 'react';
import classnames from 'classnames';
import { IconType, Icon } from '../icon';

import { noop } from '@@/utils';
import styles from './index.module.less';

interface IconBtnProps {
  type: IconType;
  className?: string;
  onClick?(): void;
}

export const IconBtn: FC<IconBtnProps> = ({ type, onClick = noop, className = '' }) => (
  <a className={classnames(styles['icon-btn'], className)} onClick={onClick}>
    <Icon type={type} />
  </a>
);
